// src/config/brands/aurex.js

// Brand color constants
const AUREX_THEME_PRIMARY = '#E51046';
const BLACK = '#1d1d1d';
const NEUTRAL_DARK = '#272727';
const PRIMARY_FONT_FAMILY = 'Univers LT Std';

export const aurexBrandConfig = {
    isAurex: true,
    title: 'AuReX',
    favicon: 'favicon-aurex.ico',
    appleTouchIcon: 'Logos/aurex/apple-touch-icon.png',
    theme: {
        primaryColor: '#1d1d1d',
        secondaryColor: '#666666',
        backgroundColor: '#f1f1f1'
    },
    fonts: {
        primary: PRIMARY_FONT_FAMILY,
        display: PRIMARY_FONT_FAMILY,
        bold: 'Univers LT Std-Bold',
        light: 'Univers LT Std-Light',
        ultra: 'Univers LT Std-Ultra',
        mono: 'Droid Sans Mono',
        letterSpacing: '0.5px',
        textFontFamily: PRIMARY_FONT_FAMILY,
    },
    fontFiles: [
        {
            family: 'Univers LT Std',
            src: "url('Fonts/aurex/UniversLTStd-Cn.otf') format('opentype')"
        },
        {
            family: 'Univers LT Std-Bold',
            src: "url('Fonts/aurex/UniversLTStd-BoldCn.otf') format('opentype')"
        },
        {
            family: 'Univers LT Std-Light',
            src: "url('Fonts/aurex/UniversLTStd-LightCn.otf') format('opentype')"
        },
        {
            family: 'Univers LT Std-Ultra',
            src: "url('Fonts/aurex/UniversLTStd-UltraCn.otf') format('opentype')"
        },
        {
            family: 'Univers LT Std-Light-Ultra-Condensed',
            src: "url('Fonts/aurex/Univers-LT-Std-49-Light-Ultra-Condensed_46334.ttf') format('opentype')"
        },
        {
            family: 'Droid Sans Mono',
            src: "url('Fonts/DroidSansMono.ttf')"
        }
    ],
    logos: {
        main: 'Logos/aurex/aurex-logo.png',
        icon: 'Logos/aurex/aurex-logo.png'
    },
    companyInfo: {
        name: 'AuReX',
        fullName: 'AuReX Solutions',
        website: 'https://www.aurex.com'
    },
    manifest: {
        name: 'AuRe-X by Hörluchs',
        short_name: 'AuRe-X',
        description: 'AuRe-X by Hörluchs',
        icons: [
            {
                src: 'Logos/aurex/AuRe-X-Logo_96x96.png',
                sizes: '96x96',
                type: 'image/png'
            },
            {
                src: 'Logos/aurex/AuRe-X-Logo_144x144.png',
                sizes: '144x144',
                type: 'image/png'
            },
            {
                src: 'Logos/aurex/AuRe-X-Logo_192x192.png',
                sizes: '192x192',
                type: 'image/png'
            }
        ],
        start_url: '.',
        display: 'standalone',
        theme_color: '#000000',
        background_color: '#ffffff'
    },
    ui: {
        topMenu: {
            backgroundColor: AUREX_THEME_PRIMARY,
            borderColor: AUREX_THEME_PRIMARY,
            logoHeight: '50px',
            avatar: {
                textColor: 'white',
                fontSize: '13px',
            }
        },
        navMenu: {
            backgroundColor: AUREX_THEME_PRIMARY,
            toggleActionsColor: AUREX_THEME_PRIMARY,
            plusButtonBackgroundColor: BLACK,
            offlineTestResultBackgroundColor: 'white',
            offlineTestResultFontColor: BLACK,
            rootColor: 'white',
            cssCustomProperties: {
                '--nav-background-color': '#d80f42', // darken(#e51046, 5%)
                '--nav-text-color': 'white',
                '--nav-selected-indicator-border': '2px solid white',
            },
        },
        test: {
            instructionFontSize: '45px',
        },
        fluentTheme: {
            themePrimary: AUREX_THEME_PRIMARY,
            themeLighterAlt: '#fff9f5',
            themeLighter: '#ffe7d6',
            themeLight: '#ef2054',
            themeTertiary: '#eb0f46',
            themeSecondary: '#d90f42',
            themeDarkAlt: '#ce0e3e',
            themeDark: '#c00d3a',
            themeDarker: '#b70c37',
            neutralLighterAlt: '#faf9f8',
            neutralLighter: '#f3f2f1',
            neutralLight: '#edebe9',
            neutralQuaternaryAlt: '#e1dfdd',
            neutralQuaternary: '#d0d0d0',
            neutralTertiaryAlt: '#c8c6c4',
            neutralTertiary: '#c2c2c2',
            neutralSecondary: '#858585',
            neutralPrimaryAlt: '#4b4b4b',
            neutralPrimary: '#333333',
            neutralDark: NEUTRAL_DARK,
            black: BLACK,
            white: '#ffffff',
            red: '#E50F46',
            blue: '#037399',
            green: '#12B361',
            lightGrey: '#666666',
            transparentGrey: '#000'
        }
    }
};
